import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { httpGet, httpPost, httpPut } from '../../../../Util/http';
import { Scrollbars } from 'react-custom-scrollbars';

const propTypes = {}

const defaultProps = {}

class Apvs extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        let apvs = this.props.apvs.map((a) => {
            let sel = this.props.selected[a.id]
            if(this.props.onlyShowSelected && !sel) {
                return
            } else {
                return (
                    <div
                        className="waves-btn"
                        key={a.id}
                        style={{ display: 'flex', cursor: 'pointer', height: 40, }}
                        onClick={() => this.props.toggleApv(a)}
                    >
                        {sel ?
                            <i style={{ paddingTop: 1, paddingRight: 4 }} className="fa fa-check-square-o" />
                            :
                            <i style={{ paddingTop: 1, paddingRight: 4 }} className="fa fa-square-o" />

                        }
                        <div style={sel ? { paddingLeft: 0 } : { paddingLeft: 2 }}>
                            {a.name}
                        </div>
                    </div>)
            }            
        })
        if (this.props.dontScroll) {
            return (
                <div>
                    {apvs}
                </div>
            )
        } else {
            return (
                <Scrollbars
                    style={{ height: '100%', width: '100%' }}
                    renderTrackHorizontal={props => <div {...props} className="track-horizontal" style={{ display: "none" }} />}
                    renderThumbHorizontal={props => <div {...props} className="thumb-horizontal" style={{ display: "none" }} />}
                >
                    {apvs}
                </Scrollbars>
            )
        }
    }
}

const styles = {
    input: {
        width: 20,
        outline: 'none',
        borderRadius: 0,
        '-webkit-appearance': 'none',
        '-webkit-box-shadow': 'none',
        '-moz-box-shadow': 'none',
        'box-shadow': 'none',
        boxShadow: 'none',
        ':focus': {
            outline: 'none',
            borderBottom: '1px solid ' + 'white',
        }
    }
}

Apvs.propTypes = propTypes

Apvs.defaultProps = defaultProps

export default Apvs



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Arbejdsmiljo/Apvs/apvs.js